import "./Mapsites.css";
import MapScreen from "../common/MapScreen";
import { useLocation } from "react-router-dom";
import { useState } from "react";

export default function Mapsites() {
  const location = useLocation();
  const [locationState] = useState(location?.state?.site || "")
  return (
    <>
      <MapScreen showNavigation={true} locationState={locationState} />
    </>
  );
}
